import React from "react";
import { Route, Router } from "react-router-dom";
import { connect } from "react-redux";
import cx from "classnames";
import { setMobileNavVisibility } from "../../reducers/Layout";
import { withRouter } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";
import Alert from "sweetalert-react";
import SideBar from "../../components/SideBar";
import ThemeOptions from "../../components/ThemeOptions";
import MobileMenu from "../../components/MobileMenu";
/**
 * Pages
 */

import Car from "../CAR";
import CapitalPlanning from "../CapitalPlanning";
import Icaap from "../ICAAP";
import User from "../User";
import Role from "../Role";
import UserProfile from "../UserProfile";
import Dashboard from "../Dashboard";
import Activities from "../Activities";
import ConfigParamaters from "../Config";
import MasterTable from "../MasterTable";
import RAROC from "../RAROC";
import WelcomeScreen from "../Dashboard/Dashboard";
import LiquidityRatio from "../LiquidityRatio";

const Main = ({ mobileNavVisibility, hideMobileMenu, history }) => {
  history.listen(() => {
    if (mobileNavVisibility === true) {
      hideMobileMenu();
    }
  });
  return (
    <div
      className={cx({
        "nav-open": mobileNavVisibility === true,
      })}
    >
      <div className="wrapper">
        <div className="close-layer" onClick={hideMobileMenu}></div>
        <SideBar backgroundImage="../../assets/icons/EY-logo.png" />

        <div className="main-panel">
          <Header />
          {/* Only render WelcomeScreen for exact "/" path */}
          <Route exact path="/" component={WelcomeScreen} />
          <Route path="/car" component={Car} />
          <Route path="/capital-planning" component={CapitalPlanning} />
          <Route path="/icaap" component={Icaap} />
          <Route path="/master-table" component={MasterTable} />
          <Route path="/config" component={ConfigParamaters} />
          <Route path="/user" component={User} />
          <Route path="/role" component={Role} />
          <Route path="/activities" component={Activities} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/raroc" component={RAROC} />
          <Route path="/liquidity-ratio" component={LiquidityRatio} />
          {/* <Route path="/config-risk-weight" component={ConfigSRW} /> */}
          {/* <Route path="/profile" component={UserProfile} /> */}
          <Footer />
        </div>
      </div>
    </div>
  );
};

const mapStateToProp = (state) => ({
  mobileNavVisibility: state.Layout.mobileNavVisibility,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  hideMobileMenu: () => dispatch(setMobileNavVisibility(false)),
});

export default withRouter(connect(mapStateToProp, mapDispatchToProps)(Main));



// WEBPACK FOOTER //
// ./src/pages/Main/index.js